// Keep the storage key in sync with the inline script in templates/base.html.twig
// (and with the Tailwind reference theme, which uses the same key).
const STORAGE_KEY = 'theme';

export default function initColorModeToggle() {
    const buttons = document.querySelectorAll('[data-color-mode-toggle]');
    if (!buttons.length) {
        return;
    }

    const root = document.documentElement;
    const isDark = () => root.getAttribute('data-bs-theme') === 'dark';
    const syncPressed = () => {
        buttons.forEach((button) => button.setAttribute('aria-pressed', isDark() ? 'true' : 'false'));
    };

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const next = isDark() ? 'light' : 'dark';
            root.setAttribute('data-bs-theme', next);
            try {
                localStorage.setItem(STORAGE_KEY, next);
            } catch (e) {
                // Storage can be blocked (private mode); the switch still works for this page view.
            }
            syncPressed();
        });
    });

    syncPressed();

    // Mode "system": the inline head script changes the attribute when the operating system scheme changes.
    new MutationObserver(syncPressed).observe(root, { attributes: true, attributeFilter: ['data-bs-theme'] });
}
